import { useState } from 'react'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'

const PASSCODE = 'waithere2026'

const TAGS = ['Todos', 'Covers', 'Anúncios', 'Logo']

const ASSETS = [
  {
    name: 'Cover Photo',
    filename: 'waithere-cover.png',
    src: '/assets/waithere-cover.png',
    tag: 'Covers',
    dimensions: '1024 × 1024',
  },
  {
    name: 'Carousel 1 — Hook',
    filename: 'carousel-01-hook.png',
    src: '/assets/carousel-01-hook.png',
    tag: 'Anúncios',
    dimensions: '1080 × 1080',
  },
  {
    name: 'Carousel 2 — Problema',
    filename: 'carousel-02-problem.png',
    src: '/assets/carousel-02-problem.png',
    tag: 'Anúncios',
    dimensions: '1080 × 1080',
  },
  {
    name: 'Carousel 3 — Virada',
    filename: 'carousel-03-flip.png',
    src: '/assets/carousel-03-flip.png',
    tag: 'Anúncios',
    dimensions: '1080 × 1080',
  },
  {
    name: 'Carousel 4 — Reveal',
    filename: 'carousel-04-reveal.png',
    src: '/assets/carousel-04-reveal.png',
    tag: 'Anúncios',
    dimensions: '1080 × 1080',
  },
  {
    name: 'Carousel 5 — CTA',
    filename: 'carousel-05-cta.png',
    src: '/assets/carousel-05-cta.png',
    tag: 'Anúncios',
    dimensions: '1080 × 1080',
  },
  {
    name: 'Logo — Fundo Claro',
    filename: 'waitherelogo.png',
    src: '/waitherelogo.png',
    tag: 'Logo',
    dimensions: '533 × 141',
    bgClass: 'bg-neutral-50',
  },
  {
    name: 'Logo — Fundo Escuro',
    filename: 'waitherelogo.png',
    src: '/waitherelogo.png',
    tag: 'Logo',
    dimensions: '533 × 141',
    bgClass: 'bg-[#111]',
    imgClass: 'brightness-0 invert',
  },
]

export default function PrivateContent() {
  const [input, setInput] = useState('')
  const [unlocked, setUnlocked] = useState(
    () => sessionStorage.getItem('wtr_private') === '1'
  )
  const [error, setError] = useState(false)
  const [activeTag, setActiveTag] = useState('Todos')

  const filteredAssets = activeTag === 'Todos'
    ? ASSETS
    : ASSETS.filter((a) => a.tag === activeTag)

  const handleSubmit = (e) => {
    e.preventDefault()
    if (input === PASSCODE) {
      sessionStorage.setItem('wtr_private', '1')
      setUnlocked(true)
      setError(false)
    } else {
      setError(true)
    }
  }

  if (!unlocked) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center px-5">
        <SEO path="/content" title="Acesso restrito — WaitHere" />
        <form
          onSubmit={handleSubmit}
          className="w-full max-w-sm text-center"
        >
          <div className="w-14 h-14 bg-black rounded-2xl flex items-center justify-center mx-auto mb-6">
            <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <h1 className="text-2xl font-black tracking-tight mb-2">Acesso restrito</h1>
          <p className="text-neutral-400 text-sm mb-8">
            Este conteúdo é privado. Digite a senha para continuar.
          </p>
          <input
            type="password"
            value={input}
            onChange={(e) => { setInput(e.target.value); setError(false) }}
            placeholder="Senha"
            className={`w-full px-4 py-3.5 rounded-xl border ${error ? 'border-red-400 bg-red-50' : 'border-neutral-200 bg-neutral-50'} text-center text-base font-medium outline-none focus:border-black transition-colors`}
            autoFocus
          />
          {error && (
            <p className="text-red-500 text-sm mt-2">Senha incorreta</p>
          )}
          <button
            type="submit"
            className="w-full mt-4 bg-black text-white font-bold py-3.5 rounded-full text-base hover:opacity-90 active:scale-[0.98] transition-all cursor-pointer"
          >
            Entrar
          </button>
          <Link to="/" className="block mt-6 text-sm text-neutral-400 no-underline hover:text-black transition-colors">
            ← Voltar ao site
          </Link>
        </form>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-white">
      <SEO path="/content" title="Conteúdo privado — WaitHere" />

      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/97 backdrop-blur-md border-b border-neutral-200">
        <div className="flex items-center justify-between px-5 py-4 md:px-10 lg:px-16">
          <Link to="/" className="no-underline">
            <img src="/waitherelogo.png" alt="Waithere" className="h-7 w-auto" />
          </Link>
          <div className="flex items-center gap-4">
            <span className="text-xs font-semibold text-neutral-400 uppercase tracking-wider">Área privada</span>
            <button
              onClick={() => { sessionStorage.removeItem('wtr_private'); setUnlocked(false) }}
              className="text-sm text-neutral-400 hover:text-black transition-colors bg-transparent border-none cursor-pointer"
            >
              Sair
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-[1080px] mx-auto px-5 py-12 md:px-10 lg:py-20">
        {/* Title */}
        <h1 className="text-[36px] md:text-[48px] font-black tracking-[-1.5px] leading-[1.1] mb-3">
          Assets
        </h1>
        <p className="text-lg text-neutral-500 leading-relaxed mb-10 max-w-[640px]">
          Materiais de marketing, anúncios e assets de marca. Clique no ícone para baixar.
        </p>

        {/* Filter tabs */}
        <div className="flex gap-2 mb-8 flex-wrap">
          {TAGS.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTag(tab)}
              className={`px-4 py-2 rounded-full text-sm font-semibold cursor-pointer transition-colors border-none ${activeTag === tab ? 'bg-black text-white' : 'bg-neutral-100 text-neutral-500 hover:bg-neutral-200'}`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Assets Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mb-16">
          {filteredAssets.map((asset) => (
            <div
              key={asset.name}
              className="group rounded-2xl border border-neutral-200 overflow-hidden hover:border-neutral-400 transition-colors"
            >
              {/* Thumbnail */}
              <div className={`relative aspect-[16/9] overflow-hidden flex items-center justify-center ${asset.bgClass || 'bg-neutral-100'}`}>
                <img
                  src={asset.src}
                  alt={asset.name}
                  className={`${asset.bgClass ? 'max-w-[60%] max-h-[60%] object-contain' : 'w-full h-full object-cover'} ${asset.imgClass || ''}`}
                />
                {/* Download overlay */}
                <a
                  href={asset.src}
                  download={asset.filename}
                  className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all flex items-center justify-center opacity-0 group-hover:opacity-100"
                >
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg transform scale-75 group-hover:scale-100 transition-transform">
                    <svg className="w-5 h-5 text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                    </svg>
                  </div>
                </a>
              </div>

              {/* Info row */}
              <div className="flex items-center gap-3 p-4">
                <div className="flex-1 min-w-0">
                  <div className="font-bold text-sm truncate">{asset.name}</div>
                  <div className="text-xs text-neutral-400 mt-0.5">
                    {asset.tag} · {asset.dimensions}
                  </div>
                </div>
                <a
                  href={asset.src}
                  download={asset.filename}
                  className="flex-shrink-0 w-9 h-9 rounded-lg bg-neutral-100 hover:bg-black hover:text-white text-neutral-400 flex items-center justify-center transition-all"
                  title={`Baixar ${asset.name}`}
                >
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                  </svg>
                </a>
              </div>
            </div>
          ))}

          {/* Add new asset placeholder */}
          <div className="rounded-2xl border-2 border-dashed border-neutral-200 flex flex-col items-center justify-center min-h-[240px] text-neutral-300 hover:border-neutral-400 hover:text-neutral-500 transition-colors cursor-default">
            <svg className="w-10 h-10 mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
            </svg>
            <span className="text-sm font-semibold">Próximo asset</span>
          </div>
        </div>

        {/* Quick Links */}
        <section className="mb-16">
          <h2 className="text-xl font-black tracking-tight mb-5">Links Rápidos</h2>
          <div className="grid md:grid-cols-2 gap-3">
            {[
              { label: 'Dashboard', url: 'https://dash.waithere.com.br', desc: 'Painel de controle' },
              { label: 'WhatsApp', url: 'https://wa.me/5547984916254', desc: 'Canal de suporte' },
              { label: 'Instagram', url: 'https://www.instagram.com/waithere.br', desc: '@waithere.br' },
              { label: 'Facebook', url: 'https://www.facebook.com/share/1Nusjwxxz3/', desc: 'Página oficial' },
            ].map((link) => (
              <a
                key={link.label}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 p-4 rounded-xl border border-neutral-200 no-underline text-black hover:border-black transition-colors group"
              >
                <div className="flex-1">
                  <div className="font-bold text-sm">{link.label}</div>
                  <div className="text-xs text-neutral-400">{link.desc}</div>
                </div>
                <svg className="w-4 h-4 text-neutral-300 group-hover:text-black transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>
            ))}
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="border-t border-neutral-200 px-5 py-8 text-center">
        <p className="text-sm text-neutral-400">
          Conteúdo privado — WaitHere © 2026
        </p>
      </footer>
    </div>
  )
}
